/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
const ContentListIcon = ({ isActive = false, className = "" }) => {
  let fill;
  if (isActive === false) {
    fill = "#9a9a9a";
  } else {
    fill = "white";
  }

  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      test-id="6mR95szs"
    >
      <path
        d="M6.99943 10.4849L8.09354 8.0496L10.5288 6.95548L8.09354 5.86136L6.99943 3.42607L5.90531 5.86136L3.47001 6.95548L5.90531 8.0496L6.99943 10.4849ZM2.05825 13.3084C1.67001 13.3084 1.33754 13.1703 1.06084 12.8941C0.784602 12.6174 0.646484 12.2849 0.646484 11.8967V2.0143C0.646484 1.62607 0.784602 1.2936 1.06084 1.01689C1.33754 0.740657 1.67001 0.602539 2.05825 0.602539H11.9406C12.3288 0.602539 12.6613 0.740657 12.938 1.01689C13.2142 1.2936 13.3524 1.62607 13.3524 2.0143V11.8967C13.3524 12.2849 13.2142 12.6174 12.938 12.8941C12.6613 13.1703 12.3288 13.3084 11.9406 13.3084H2.05825ZM2.05825 11.8967H11.9406V2.0143H2.05825V11.8967Z"
        fill={fill}
        test-id="qwQCV8Cg"
      />
    </svg>
  );
};

export default ContentListIcon;
